import { array, Decoder, field, nullable, object, string } from 'json-bouncer'
import {BpsUser, bpsUserDecoder} from './BpsUser'
import * as PrismaFile from './PrismaFile'
import * as PrismaRequest from './PrismaRequest'
import {
    PrismaRequestCommentWithUsers,
    prismaRequestCommentWithUsersDecoder
} from './PrismaRequestCommentWithUsers'
import * as PrismaRequestOfferWithManufacturerStatus
    from './PrismaRequestOfferWithManufacturerStatus'
import * as PrismaRequestDeliveryInformation
    from './PrismaRequestDeliveryInformation'
import {Product, productDecoder} from './Product'
import {
    TranslatedProductAttribute,
    translatedProductAttributeDecoder
} from './TranslatedProductAttribute'
import { ParcelDispatcher, parcelDispatcherDecoder } from './ParcelDispatcher'

export interface M {
    readonly prismaRequest: PrismaRequest.M
    readonly printOffer: PrismaRequestOfferWithManufacturerStatus.M | null
    readonly lithoOffer: PrismaRequestOfferWithManufacturerStatus.M | null
    readonly bpsUser: BpsUser
    readonly translatedProductAttributes: TranslatedProductAttribute[]
    readonly prismaRequestCommentsWithUsers: PrismaRequestCommentWithUsers[]
    readonly printProduct: Product
    readonly attachmentFiles: PrismaFile.M[]
    readonly proofCopyFiles: PrismaFile.M[]
    readonly printFiles: PrismaFile.M[]
    readonly printSapOrderNumber: string | null
    readonly lithoSapOrderNumber: string | null
    readonly assignedAdminName: string | null
    readonly assignedAdminEmail: string | null
    readonly deliveryInformation: PrismaRequestDeliveryInformation.M | null
    readonly selectableParcelDispatchers: ParcelDispatcher[] | null
}

export function decoder(): Decoder<M> {
    return object({
        prismaRequest: field('prismaRequest', PrismaRequest.decoder()),
        printOffer:
            field(
                'printOffer',
                nullable(PrismaRequestOfferWithManufacturerStatus.decoder())
            ),
        lithoOffer:
            field(
                'lithoOffer',
                nullable(PrismaRequestOfferWithManufacturerStatus.decoder())
            ),
        bpsUser: field('bpsUser', bpsUserDecoder()),
        translatedProductAttributes:
            field(
                'translatedProductAttributes',
                array(translatedProductAttributeDecoder()),
            ),
        prismaRequestCommentsWithUsers:
            field(
                'prismaRequestCommentsWithUsers',
                array(prismaRequestCommentWithUsersDecoder()),
            ),
        printProduct: field('printProduct', productDecoder()),
        attachmentFiles: field('attachmentFiles', array(PrismaFile.decoder())),
        proofCopyFiles: field('proofCopyFiles', array(PrismaFile.decoder())),
        printFiles: field('printFiles', array(PrismaFile.decoder())),
        printSapOrderNumber: field('printSapOrderNumber', nullable(string())),
        lithoSapOrderNumber: field('lithoSapOrderNumber', nullable(string())),
        assignedAdminName: field('assignedAdminName', nullable(string())),
        assignedAdminEmail: field('assignedAdminEmail', nullable(string())),
        deliveryInformation: field(
            'deliveryInformation',
            nullable(PrismaRequestDeliveryInformation.decoder())
        ),
        selectableParcelDispatchers: field(
            'selectableParcelDispatchers',
            nullable(array(parcelDispatcherDecoder()))
        )
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestWithDetails.ts